module.exports = __webpack_public_path__ + "img/ci.d3348b09.svg";